<template>
    <div>

        <div class="tab-box">
            <a href="https://www.yirendai.com/support/" class="problem">支付遇到问题？</a>
            <el-tabs v-model="activeName">
                <el-tab-pane label="快捷支付" name="kj"></el-tab-pane>
                <!--<el-tab-pane label="网银支付" name="wy"></el-tab-pane>-->
            </el-tabs>

        </div>
        <!--快捷支付-->
        <div class="card-box" v-loading="loading"  v-if="activeName=='kj'">
            <div class="header">
                <div class="left">快捷支付（储蓄卡） <a href="https://www.yirendai.com/support/others/kuaijiezhifu/201504282751.html">如何开通</a></div>
                <div class="right">为了您能顺利完成支付，建议您使用IE浏览器</div>
            </div>
            <div class="clearfix"></div>

            <div class="content clearfix">
                <ul class="bankcard-list clearfix">
                    <li v-for="(item, index) in banksData.kjBanks">
                        <div class="radio" :class="{ active: item.isActive,disabled:item.supportQuick=='false' }" @click="handleKjSelect(index,item)"></div>
                        <div class="card">
                            <div class="head">
                                <img :src="`${baseUrl}miniBank/${item.bankEnShortName.toUpperCase()}.png`" alt="">
                                <span> &nbsp;&nbsp;储蓄卡</span>
                            </div>
                            <div class="body">
                                <p>{{item.bankCardNo}}</p>
                            </div>
                            <div class="footer">
                                <div class="left">支付限制：{{item.limitAmount}} 元</div>

                            </div>
                            <div :class="{mask:item.supportQuick=='false'}"></div>

                        </div>

                    </li>
                    <li class="addBtn-box">
                        <div class="card">
                            <a href="javascript:;" @click="bind" class="addBtn">添加银行卡</a>
                        </div>

                    </li>
                </ul>
                <div class="clearfix"></div>
                <!--<div class="more-box">-->
                    <!--<a href="javascript:;" @click="showMoreBanks">更多银行 >></a>-->

                <!--</div>-->
            </div>

        </div>


        <!--网银支付-->
        <!--<div class="card-box" v-loading="loading"  v-if="activeName=='wy'">-->
            <!--<div class="header">-->
                <!--<div class="left">网银支付（储蓄卡）</div>-->
                <!--<div class="right">为了您能顺利完成支付，建议您使用IE浏览器</div>-->
            <!--</div>-->
            <!--<div class="clearfix"></div>-->

            <!--<div class="content clearfix">-->
                <!--<ul class="minicard-list clearfix">-->
                    <!--<li v-for="(item, index) in banksData.wyBanks" :class="{ active: item.isActive }" @click="handleWySelect(index,item)">-->
                        <!--<div class="minicard">-->
                            <!--<img :src="`${baseUrl}miniBank/${item.bankEnShortName.toUpperCase()}.png`" alt="">-->



                        <!--</div>-->

                    <!--</li>-->

                <!--</ul>-->
                <!--<div class="clearfix"></div>-->

            <!--</div>-->

        <!--</div>-->

        <!--end 网银支付-->
    </div>
</template>
<template>
    <div>

        <div class="tab-box">
            <a href="https://www.yirendai.com/support/" class="problem">支付遇到问题？</a>
            <el-tabs v-model="activeName">
                <el-tab-pane label="快捷支付" name="kj"></el-tab-pane>
                <!--<el-tab-pane label="网银支付" name="wy"></el-tab-pane>-->
            </el-tabs>

        </div>
        <!--快捷支付-->
        <div class="card-box" v-loading="loading"  v-if="activeName=='kj'">
            <div class="header">
                <div class="left">快捷支付（储蓄卡） <a @click="doLog(`PC支付-${logText}-如何开通`)" target="_blank" href="https://www.yirendai.com/support/others/kuaijiezhifu/201504282751.html">如何开通</a></div>
                <div class="right">为了您能顺利完成支付，建议您使用IE浏览器</div>
            </div>
            <div class="clearfix"></div>

            <div class="content clearfix">
                <ul class="bankcard-list clearfix">
                    <li v-for="(item, index) in banksData.kjBanks">
                        <div class="radio" :class="{ active: item.isActive,disabled:item.supportQuick=='false' }" @click="handleKjSelect(index,item)"></div>
                        <div class="card">
                            <div class="head">
                                <img :src="`${baseUrl}miniBank/${item.bankEnShortName.toUpperCase()}.png`" alt="">
                                <span> &nbsp;&nbsp;储蓄卡</span>
                            </div>
                            <div class="body">
                                <p>{{item.bankCardNo}}</p>
                            </div>
                            <div class="footer">
                                <div class="left">支付限制：{{item.limitAmount}} 元</div>

                            </div>
                            <div :class="{mask:item.supportQuick=='false'}"></div>

                        </div>

                    </li>
                    <li class="addBtn-box">
                        <div class="card">
                            <a href="javascript:;" @click="showTip=true;doLog('PC支付-充值快捷支付-添加银行卡')" class="addBtn">添加银行卡</a>
                        </div>

                    </li>
                </ul>
                <div class="clearfix"></div>
                <!--<div class="more-box">-->
                <!--<a href="javascript:;" @click="showMoreBanks">更多银行 >></a>-->

                <!--</div>-->
            </div>

        </div>


        <!--网银支付-->
        <!--<div class="card-box" v-loading="loading"  v-if="activeName=='wy'">-->
        <!--<div class="header">-->
        <!--<div class="left">网银支付（储蓄卡）</div>-->
        <!--<div class="right">为了您能顺利完成支付，建议您使用IE浏览器</div>-->
        <!--</div>-->
        <!--<div class="clearfix"></div>-->

        <!--<div class="content clearfix">-->
        <!--<ul class="minicard-list clearfix">-->
        <!--<li v-for="(item, index) in banksData.wyBanks" :class="{ active: item.isActive }" @click="handleWySelect(index,item)">-->
        <!--<div class="minicard">-->
        <!--<img :src="`${baseUrl}miniBank/${item.bankEnShortName.toUpperCase()}.png`" alt="">-->



        <!--</div>-->

        <!--</li>-->

        <!--</ul>-->
        <!--<div class="clearfix"></div>-->

        <!--</div>-->

        <!--</div>-->

        <!--end 网银支付-->


        <el-dialog
                title="提示"
                :visible.sync="showTip"
                width="750px"
                :close-on-click-modal="false"
                top="20vh"

        >
            <div class="banksAvailable-box">
                <p class="tip-text">为避免您添加的新卡不支持还款功能，请在广发存管账号添加以下银行的储蓄卡：</p>
                <ul class="minicard-list clearfix">
                    <li v-for="(item, index) in banksData.wyBanks">
                        <div class="minicard">
                            <img :src="`${baseUrl}miniBank/${item.bankEnShortName.toUpperCase()}.png`" alt="">

                        </div>

                    </li>

                </ul>


            </div>
            <div class="btn-box">
                <el-button size="medium" type="primary" @click="bind" >好的</el-button>
            </div>

        </el-dialog>

    </div>
</template>


<script>
	export default {
		name: "bankList",
        data(){
            return {
                loading:false,
                baseUrl:process.env.BASE_URL,
                activeName: 'kj',
				kjbindCardId:'',
                wyBankId:'',
                showTip:false

            }

        },
        watch:{
			"activeName":function(val){
				this.$store.commit('SET_TABNAME', val)
            }
        },
		computed:{

			banksData(){
				return  this.$store.state.payBanksData
			}
		},
        methods:{
            handleKjSelect(index,item){
                console.log(item)

				if(item.supportQuick == 'false'){
                    return false
					this.doLog(`PC支付-${this.logText}-点击不可选卡`)

				}
				this.doLog(`PC支付-${this.logText}-点击可选卡`)

				this.banksData.kjBanks.forEach( (item,i)=> {
                    this.$set(item,'isActive',false)
                })
                this.$set(this.banksData.kjBanks[index],'isActive',true)
                this.kjbindCardId=this.banksData.kjBanks[index]['bindCardId']
                this.$store.commit('SET_KJBINDCARDID', this.kjbindCardId)
            },
            handleWySelect(index,item){
                console.log(item)
                if(item.isPay == 'false'){
                    return false
                }
                this.banksData.wyBanks.forEach( (item,i)=> {
                    this.$set(item,'isActive',false)
                })
                this.$set(this.banksData.wyBanks[index],'isActive',true)
                this.wyBankId=this.banksData.wyBanks[index]['bankId']
                this.$store.commit('SET_WYBANKID', this.wyBankId)
            },


            getKjBanks(){
                this.loading = true
                this.$axios({
                    method: 'get',
                    url: '/recharge/bankcards/HuiMinlist'
                }).then( (res) =>{
                    this.loading = false
                    console.log(res)
                    if(res.result){
                        this.$store.commit('SET_KJBANKS',res.data)

                    }else{
                        this.$alert(res.message, '提示', {
                            confirmButtonText: '确定',
                        });
                    }
                }).catch( (err)=> {
                    this.loading = false
                    alert('系统错误,请稍后再试')

                    console.warn(err)
                })
            },
            getWyBanks(){
                this.$axios({
                    method: 'get',
                    url: '/recharge/supportBanks/list?payType=1',
                }).then( (res) =>{
                    console.log(res)
                    if(res.result){
                        this.$store.commit('SET_WYBANKS',res.data)

                    }else{
                        this.$alert(res.message, '提示', {
                            confirmButtonText: '确定',
                        });
                    }
                }).catch( (err)=> {
                    alert('系统错误,请稍后再试')

                    console.warn(err)
                })
            },

            bind(){


                this.$axios({
                    method: 'get',
                    url: '/user/supervise/bankcards/HuiMinbind',
                    params:{returnUrl:window.location.protocol+'//'+window.location.host+'/pcloan/user/recharge2'}
                }).then( (res) =>{
                    console.log(res.data.url)
                    if(res.result){
                        // return console.log(res.data.url)
                        this.$router.push({name:'guangfaRedirect',query:{redirect:encodeURIComponent(res.data.url)}})


                    }else{
                        this.$alert(res.message, '提示', {
                            confirmButtonText: '确定',
                        });
                    }

                }).catch(function (err) {
                    console.warn(err)
                })
            }
        },
        created(){
            this.getKjBanks()
            //获取快捷支付支持的银行

            this.getWyBanks()
			const dictPay = {
				"monthlyPayHeng2":"还款快捷支付-按月还款",
				"payAllHeng2":"还款快捷支付-一次性结清",
				"recharge2":"充值快捷支付"
			}
			let payType = this.$route.name
			this.logText =dictPay[payType];
        }
	}
</script>

<style scoped lang="scss">
    .tab-box{
        margin-top:30px;
        position:relative;
        .problem{
            position:absolute;
            right:0;
            top:0;
            z-index: 100;
        }
    }
    .card-box{

        /*background-color: #f8f8f8;*/
        .header{
            background-color: #f0f2f4;
            line-height:24px;
            overflow: hidden;
            padding:10px;
            .left{float:left;font-size:14px;
                color:#333333;}
            .right{
                float:right;
                font-size:12px;
                color:#999999;
            }
        }
        .content{ margin-bottom:20px;}

        .content .minicard-list{
            background: #F8F8F8;
            li{
                float:left;
                margin:20px 0px 20px 18px;
                padding-left:30px;
                height:54*0.75px;
                background: url("../assets/images/radio.png") 0 center no-repeat;
                background-size: 24px;
                float:left;


                .minicard{

                    background-color: #ffffff;
                    float:left;
                    position:relative;
                    img{width:190*0.75px;height:54*0.75px;}
                }
            }
            .active{
                background: url("../assets/images/redio_active.png") 0 center no-repeat;
                background-size: 24px;

            }
        }
        .content .bankcard-list{
            background: #F8F8F8;


            li{
                float:left;
                margin:20px 0px 20px 9px;
                padding:0;
                .radio{
                    width:24px;
                    height:24px;
                    background: url("../assets/images/radio.png") 0 0 no-repeat;
                    background-size: 100%;
                    float:left;
                    margin-top:55px;
                    margin-right:2px;
                }
                .active{
                    background: url("../assets/images/redio_active.png") 0 0 no-repeat;
                    background-size: 100%;

                }
                .disabled {
                    background-color: #f5f7fa;
                    border-color: #e4e7ed;
                    cursor: not-allowed;
                    border-radius: 12px;
                }

                .card{
                    width:222px;
                    height:134px;
                    border: 1px solid #ddd;
                    background-color: #ffffff;
                    float:left;
                    position:relative;
                    .mask{
                        background-color: rgba(221,221,221,0.5);
                        width:100%;
                        position:absolute;
                        left: 0;
                        right: 0;
                        top:0;
                        bottom:0;
                        cursor: not-allowed;

                    }
                    .head{
                        height:37.33px;
                        background:#ffffff;
                        border-bottom: 1px solid #ddd;
                        position:relative;
                        overflow: hidden;
                        img{width:128px;height:36.38px;}
                        span{
                            color:#f68321;
                            position: absolute;top:0;right:0;font-size:12px;line-height:50px;display: inline-block;width:80px;height:40px;background-color: #fff6d7;border-radius:15px;margin-top:-13px;margin-right:-30px;
                            text-align: left;vertical-align: bottom;
                        }
                    }
                    .body{
                        height:45px;
                        border-bottom: 1px solid #ddd;
                        padding:10px;
                        p{
                            line-height:40px;
                            vertical-align: middle;


                        }
                    }
                    .footer{
                        font-size:12px;
                        line-height:30px;
                        padding: 0 10px;
                        color:#999999;
                        .left{float:left;}
                        .right{float:right;}
                    }
                }

            }
            li.addBtn-box{
                padding-left:25px;
                text-align: center;
                .addBtn{
                    font-family:PingFangSC-Regular;
                    font-size:14px;
                    color:#5078e6;
                    text-decoration: underline;
                    display: inline-block;
                    height:124px;
                    line-height:124px;
                    padding-left:30px;
                    background: url("../assets/images/icon-add.png") 0 center no-repeat;
                    background-size: 24px 24px;


                }
            }

        }
        .more-box{
            padding:40px;
        }
    }
    .banksAvailable-box{
        .tip-text{
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #666666;
        }

        .minicard-list{
            li{
                float:left;
                margin:20px 0px 20px 18px;
                height:44px;
                background-size: 24px;
                float:left;


                .minicard{

                    background-color: #ffffff;
                    float:left;
                    position:relative;
                    img{width:152px;height:44px;}
                }
            }
        }
    }
</style>
